import merge from 'lodash.merge';
import useAnalytics from "./useAnalytics";
export default globalConfig => {
  const analytics = useAnalytics();
  return configFn => () => {
    analytics && analytics.push(dataLayer => {
      return merge({
        type: 'click'
      }, globalConfig ? globalConfig(dataLayer) : {}, configFn ? configFn(dataLayer) : {});
    });
  };
};